// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-vantage -> price-brothers-vantage -> millcreek-woods-apartment-homes
// Generated: 2026-11-03T22:58:04.761Z
// Counts: 0 design, 66 content, 11 slot group, 1 collection binding, 8 section, 1 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_address_city\"></span> Apartments For Rent</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Inclusive access for every visitor</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Comfort and convenience at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply for <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom apartments at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reach our leasing team today</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Contact Us</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Answers to the questions residents ask most at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom apartments for rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Floor Plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.lets_talk_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Your New <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span> Apartment is Waiting</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>See life at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Gallery</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Explore the <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span> Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Neighborhood</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet-friendly living at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 14px;\">Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Exclusive move-in savings at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Program Benefits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Exclusive Perks for </h2><h2>Preferred Employers</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Preferred Employers</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>How we protect your information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.grid_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Featured Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pay rent and manage your account</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Access</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident stories from <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Visit <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Schedule A Tour</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Each Price Brothers Management Co. community has its own character, amenities, and floor plans. Explore the options above to find the one that feels like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Nearby Communities From the Price Brothers Management Co.</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore More Places to Call Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Navigate every page on <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "studios-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Studio Floor Plans at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>We'll be in touch soon</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Tour Our <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom apartments at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Virtual Tours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.employers": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>City of Olathe</p></li><li><p>Garmin</p></li><li><p>Active Military</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "multihub-lead-form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "hero.rail_schedule": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "custom_self_guided_tour_url",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "scheduletourform.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167603/01a0102b-79aa-7386-86f8-94cafccb848d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment buildings on a grassy hill overlooking a large blue lake with a fountain."
      }
    }
  },
  "sisterproperties.community1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Photo of a sister community to Millcreek Woods Apartment Homes"
      }
    }
  },
  "sisterproperties.community2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Photo of a sister community to Millcreek Woods Apartment Homes"
      }
    }
  },
  "sisterproperties.community3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Photo of a sister community to Millcreek Woods Apartment Homes"
      }
    }
  },
  "sisterproperties.community4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Photo of a sister community to Millcreek Woods Apartment Homes"
      }
    }
  },
  "sisterproperties.community5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Photo of a sister community to Millcreek Woods Apartment Homes"
      }
    }
  },
  "sisterproperties.community6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Photo of a sister community to Millcreek Woods Apartment Homes"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.amenities": {
    "limit": 8,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  }
};
